(self.AMP=self.AMP||[]).push({n:"amp-animation",v:"2008071507000",f:(function(AMP,_){
$1
})});